import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { Link } from 'react-router-dom';
import './styles/references.css';
import LogoSlider from '../components/logoslider';

function References() {
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReferences = async () => {
      try {
        setLoading(true);
        
        // Hent kun referencer, der ikke er slettet
        const referencesQuery = query(
          collection(db, 'references'),
          where('erSlettet', '==', false)
        );
        
        const snapshot = await getDocs(referencesQuery);
        
        // Filter active references der har logoer
        const activeReferences = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(ref => ref.logoUrl); // Kun vis dem med logoer
        
        setReferences(activeReferences);
      } catch (error) {
        console.error("Fejl ved hentning af referencer:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReferences();
  }, []);

  return (
    <div className="references-page">
      <div className="references-hero">
        <div className="references-hero-overlay"></div>
      </div>

      <div className="references-container">
        <div className="references-intro">
          <h2>Partnerskaber, der skaber resultater</h2>
          <p>
            Vores samarbejde med vores kunder er fundamentet for alt, hvad vi gør. Det handler ikke blot om at levere ydelser, men om at skabe varige partnerskaber, hvor vi i fællesskab sikrer kvalitet, effektiv drift og løbende udvikling.
          </p>
          <p>
            Kvalitetssikring, herunder standarden DS1140, er et afgørende element i vores arbejde, og kun gennem tæt samarbejde med vores kunder kan vi sikre de bedste løsninger. Sammen skaber vi værdier, der styrker både vores kunder og os selv, og vi arbejder aktivt for at vedligeholde og optimere processer, så de lever op til de højeste standarder.
          </p>
          <p>
            Desuden er vidensdeling en central del af samarbejdet, og vores kurser om kvalitetssikring giver kunderne de rette værktøjer til at optimere deres egne arbejdsgange. Ved at lære af hinanden og bygge på hinandens ekspertise sikrer vi, at vores fælles mål om kvalitet, driftssikkerhed og udvikling bliver en realitet.
          </p>
          <p>
            Kort sagt: Samarbejde er nøglen. Det er en dynamisk proces, der kræver engagement, dialog og gensidig tillid. Kun ved at arbejde sammen kan vi skabe løsninger, der holder – både i dag og i fremtiden.
          </p>
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Indlæser referencer...</p>
          </div>
        ) : references.length > 0 ? (
          <div className="references-grid">
            {references.map(reference => (
              <Link 
                to={`/referencer/${reference.id}`} 
                key={reference.id}
                className="reference-card"
              >
                <div className="reference-logo-container">
                  <img 
                    src={reference.logoUrl} 
                    alt={`${reference.title} logo`} 
                    className="reference-logo-img"
                  />
                </div>
                <div className="reference-content">
                  <h3 className="reference-title">{reference.title}</h3>
                  <p className="reference-description">{reference.description}</p>
                  <span className="reference-link">Læs mere</span>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="no-references">
            <h3>Ingen referencer endnu</h3>
            <p>Vi arbejder på at tilføje referencer. Kom tilbage snart!</p>
          </div>
        )}
      </div>

      <LogoSlider />
    </div>
  );
}

export default References;
